import { getCurrencySymbol } from '../src/getCurrencySymbol';
export default getCurrencySymbol;
